import type { Transition } from 'framer-motion';

// ── Panel ──

/** The field growing into the panel (PANEL_MOTION_MS), as CSS transitions. */
export const PANEL_EASE_CLASS = 'duration-[340ms] ease-[cubic-bezier(0.32,0.72,0,1)]';

/** The bar shrinking back into the field: short and even. */
export const PANEL_CLOSE_EASE_CLASS = 'duration-[220ms] ease-[cubic-bezier(0.4,0,0.2,1)]';

/**
 * The dropdown under the bar grows on open; on close it never folds up (its
 * bottom edge would sweep ~400px up the page). It fades where it is, then
 * collapses unseen.
 */
export const DROPDOWN_OPEN_CLASS =
  'grid-rows-[1fr] opacity-100 [transition:grid-template-rows_340ms_cubic-bezier(0.32,0.72,0,1)]';
export const DROPDOWN_CLOSED_CLASS =
  'grid-rows-[0fr] opacity-0 [transition:opacity_120ms_ease-out,grid-template-rows_0s_120ms]';

// ── Entrance ──
// CSS animations, not motion variants: they play whenever an element mounts,
// so rows that land after the panel opened (answers, loaded sections) come in
// too. Opacity only on sections: a transform there would make the section the
// rows' offsetParent and throw off the highlight.

/**
 * A section fades in as it mounts. No delay by its place in the list: when a
 * section above drops out, the place changes and the fade would start over.
 */
export const SECTION_ENTER_CLASS =
  'animate-in fade-in fill-mode-both duration-200 motion-reduce:animate-none';

/** A row rises into place as it mounts. */
export const ROW_ENTER_CLASS =
  'animate-in fade-in slide-in-from-bottom-1.5 fill-mode-both duration-300 ease-[cubic-bezier(0.2,0.8,0.2,1)] motion-reduce:animate-none';

/** A section's rows follow one another. */
export const ROW_STAGGER_CLASS =
  '[&>li:nth-child(2)]:[animation-delay:25ms] [&>li:nth-child(3)]:[animation-delay:50ms] [&>li:nth-child(n+4)]:[animation-delay:75ms]';

// ── Leaving ──

/** Blocks folding away inside the panel: even in and out, so the rows below glide up. */
export const FOLD_TRANSITION: Transition = { duration: 0.28, ease: [0.4, 0, 0.2, 1] };

/**
 * A block leaving the list folds up, taking the 6px gap under it along, so the
 * blocks below rise into its place rather than jump.
 */
export const FOLD_EXIT = { height: 0, opacity: 0, marginBottom: -6, transition: FOLD_TRANSITION };

/** The active tab's fill slides to the next tab. */
export const INDICATOR_TRANSITION: Transition = { type: 'spring', stiffness: 500, damping: 40 };
